import React from 'react';
import PropTypes from 'prop-types';
import Box from '../../elements/Box';
import Text from '../../elements/Text';

const AirportIataCode = ({
  item,
  showAirportIataCode,
  iataCodeContainerProps,
  iataCodeLabelProps,
  labelContainerProps,
  labelProps,
  showParenthesis,
}) => {
  let { value } = item;
  if (showParenthesis) {
    value = `(${item.value})`;
  }

  return (
    <>
      {showAirportIataCode && (
        <Box {...iataCodeContainerProps}>
          <Text {...iataCodeLabelProps}>{value}</Text>
        </Box>
      )}
      <Box {...labelContainerProps}>
        <Text {...labelProps}>{item.label}</Text>
      </Box>
    </>
  );
};

AirportIataCode.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  showAirportIataCode: PropTypes.bool,
  iataCodeLabelProps: PropTypes.objectOf(PropTypes.any),
  iataCodeContainerProps: PropTypes.objectOf(PropTypes.any),
  labelProps: PropTypes.objectOf(PropTypes.any),
  labelContainerProps: PropTypes.objectOf(PropTypes.any),
  showParenthesis: PropTypes.bool,
};

AirportIataCode.defaultProps = {
  showAirportIataCode: true,
  iataCodeLabelProps: {
    paddingTop: '2px',
  },
  iataCodeContainerProps: {
    border: true,
    paddingWidth: '1',
    marginRight: '2',
    floatLeft: true,
    textAlign: 'center',
    fontWeight: 'bold',
    style: { minWidth: '45px' },
  },
  labelProps: {},
  labelContainerProps: {},
  showParenthesis: false,
};

export default AirportIataCode;
